// extracted by mini-css-extract-plugin
module.exports = {"nav":"RaffleDealTab_nav__X3R4K","wrap":"RaffleDealTab_wrap__3odwt","tab":"RaffleDealTab_tab__2_EXF","active":"RaffleDealTab_active__2A4CT"};